const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/resources/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/resources/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});